import React from 'react';
import { Heading } from '@jobber/components/Heading';
import { Button } from '@jobber/components/Button';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function NoAccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const attemptedPath = location.state?.from || '';

  return (
    <div className="container py-5">
      <div className="card p-4" style={{ maxWidth: '760px', margin: '0 auto' }}>
        <Heading level={2}>No Access</Heading>
        <p className="mt-3 mb-2">You do not have permission to view this page.</p>
        {attemptedPath ? <p className="text-muted mb-4">Requested page: {attemptedPath}</p> : null}

        <div className="d-flex gap-2 flex-wrap">
          <Button label="Go to Clients" onClick={() => navigate('/clients')} />
          <Link to="/settings?tab=access-control">
            <Button label="Open Access Control" type="secondary" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NoAccess;
